import type { ReactNode } from "react";

import { cn } from "@/shared/lib/utils";

export interface VerificationLayoutProps {
  /** Optional stepper rendered above the card. */
  stepper?: ReactNode;
  /** Card width: person (~520px) vs business (~640px). */
  size?: "person" | "business";
  className?: string;
  children: ReactNode;
}

/**
 * Frame-agnostic engine container: the central card (token `card` + `border` + `radius-2xl`) floating over
 * the `muted` background, with an optional stepper above. Reused by every verification surface; the outer
 * frame (full-screen public link, app shell, or dialog) wraps this.
 */
export function VerificationLayout({
  stepper,
  size = "person",
  className,
  children,
}: VerificationLayoutProps) {
  return (
    <div className={cn("mx-auto w-full", size === "business" ? "max-w-[640px]" : "max-w-[520px]", className)}>
      {stepper}
      <div className="rounded-2xl border border-border bg-card p-6 shadow-sm sm:p-8">{children}</div>
    </div>
  );
}
